import script from "./SearchModal.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchModal.vue?vue&type=script&setup=true&lang=js"

import "./SearchModal.vue?vue&type=style&index=0&id=0b0a9e92&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b0a9e92"]])

export default __exports__